import React, { useCallback } from 'react';

//Hooks
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';

//Actions
import { getReservations, getPastReservations } from '../../../store/actions';

//Components
import { Switch, Route, useHistory, Redirect, useRouteMatch } from 'react-router-dom';
import { Breadcrumb, Container } from 'react-bootstrap';
import ScreenHeader from '../../../components/ScreenHeader/ScreenHeader'

//Routes
import Current from '../Current/Current';
import History from '../History/History';
import Details from '../Details/Details';

import { ROUTER_URL } from '../../../const/ROUTER_URL';
import { ROUTER_PATH } from '../../../const/ROUTER_PATH';

//Styles
import Styles from './Reservations.module.scss';

const Reservations = () => {
    const isSignedIn = useSelector(state => state.auth.isSignup);
    const bookings = useSelector(state => state.reservations.bookings);
    const bundles = useSelector(state => state.reservations.bundles);
    const dispatch = useDispatch();

    const history = useHistory();
    const { t } = useTranslation('common');

    const reservationsMatch = useRouteMatch({
        path: ROUTER_PATH.RESERVATIONS,
        exact: true,
    });

    const reservationsHistoryMatch = useRouteMatch({
        path: ROUTER_PATH.RESERVATIONS_HISTORY,
        exact: true,
    });

    const handleReservationsRedirect = useCallback(() => {
        history.push(ROUTER_URL.RESERVATIONS)
    }, [history]);

    const handleReservationsHistoryRedirect = useCallback(() => {
        history.push(ROUTER_URL.RESERVATIONS_HISTORY)
    }, [history]);

    useEffect(() => {
        if (!isSignedIn) {
            return
        }

        dispatch(getReservations());
        dispatch(getPastReservations());
    }, [isSignedIn, dispatch]);

    if (!isSignedIn) {
        return <Redirect to={ROUTER_URL.SIGN_IN_RESERVATIONS} />
    }

    return (
        <>
            <ScreenHeader>
                <Breadcrumb>
                    <Breadcrumb.Item active data-testid='data-test-reservations-title'>
                        {t('reservationsScreen.reservations.header')}
                    </Breadcrumb.Item>
                    {
                        (bookings.length !== 0 || bundles.length !== 0) ?
                            <span className={Styles.count}>{bookings.length + bundles.length}</span> :
                            ''
                    }
                </Breadcrumb>
            </ScreenHeader>

            <div id="scrollContainer" className={Styles.container}>
                <Container className={'px-0'}>
                    {
                        (reservationsMatch || reservationsHistoryMatch) && (
                            <div className={Styles.navigator}>
                                <button
                                    data-testid="button1"
                                    className={reservationsMatch ? Styles.active : ''}
                                    onClick={handleReservationsRedirect}
                                >
                                    {t('reservationsScreen.current').toUpperCase()}
                                </button>
                                <button
                                    data-testid="button2"
                                    className={reservationsHistoryMatch ? Styles.active : ''}
                                    onClick={handleReservationsHistoryRedirect}
                                >
                                    {t('reservationsScreen.history').toUpperCase()}
                                </button>
                            </div>)
                    }
                </Container>

                <Switch>
                    <Route
                        path={ROUTER_PATH.RESERVATIONS}
                        exact
                        component={Current}
                    />
                    <Route
                        path={ROUTER_PATH.RESERVATIONS_HISTORY}
                        component={History}
                    />
                    <Route
                        path={ROUTER_PATH.RESERVATIONS_DETAILS_TYPE_ID_NEXT}
                        component={Details}
                    />
                </Switch>
            </div>
        </>
    )
}

export default Reservations
